<template>
  <div class="banner">
    <a-carousel autoplay :dots="false">
      <img v-for="(item,index) in bannerList" :src="item.absPicUrl" class="carousel-img" />
      <!-- <img src="@/assets/home/carousel.png" class="carousel-img" /> -->
    </a-carousel>
  </div>
  <div class="news">
    <div class="news-tips flex justify-between"><span>资讯</span><div class="more text-xs pointer" @click="toPage('/main/news')">更多<RightOutlined /></div></div>
    <div class="news-cont h-60 flex">
      <div class="news-left w-262">
        <vue3-seamless-scroll :list="leftArr" class="scroll-banner h-60" :hover="true" :step="1"  :wheel="true" :singleHeight="27">
          <div class="scroll-cell pl-15 truncate " v-for="(item, index) in leftArr" :key="index">
            {{item.title}}
          </div>
        </vue3-seamless-scroll>
      </div>
      <div class="news-left w-250">
        <vue3-seamless-scroll :list="rightArr" class="scroll-banner h-60" :hover="true" :step="1" :wheel="true" :singleHeight="27">
          <div class="scroll-cell pl-15 truncate " v-for="(item, index) in rightArr" :key="index">
            {{item.title}}
          </div>
        </vue3-seamless-scroll>
      </div>
    </div>
    
  </div>
</template>
<script setup>
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
import { RightOutlined } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
import { watch, ref } from "vue";
const props = defineProps({
  bannerList: {
    required: true, // 是否必传
    type: Array,
    default: () => []
  },
  newsObj:{
    required: true, // 是否必传
    type: Array,
    default: () => []
  }
})
const leftArr = ref([])
const rightArr = ref([])
watch(()=> props.newsObj, val=>{
      let index = Math.floor(val.length / 2);
      leftArr.value = val.slice(0,index)
      rightArr.value = val.slice(index)
    },
    { immediate: true }
  )
const router = useRouter();
function toPage(url,name){
    router.push(url)
}
</script>
<style lang="scss" scoped>
.banner {
    width: 580px;
    height: 291px;
    border-radius: 10px;

    .carousel-img {
        width: 580px;
        height: 291px;
        border-radius: 10px;
    }
}

.news {
    width: 580px;
    height: 103px;
    background: linear-gradient(180deg, #c6d5f1 0%, #dce6f9 100%);
    border-radius: 10px;
    padding: 14px;
    box-sizing: border-box;
    text-align: left;
    margin-top: 10px;
    .news-cont{
      overflow-y: hidden;
      .news-left{
        
        .scroll-cell{
          width: 250px;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          color: #333333;
          padding: 5px 15px;
          position: relative;
          &::before{
            content: '';
            position: absolute;
            top: 10px;
            left: 0px;
            display: block;
            width: 6px;
            height: 6px;
            background-color: #002564;
            border-radius: 6px;
          }
        }
      }
      .scroll-left{
        justify-content: flex-start;
      }
    }
    .news-tips {
        font-size: 16px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        color: #002564;
        margin-bottom: 9px;
        .more{
          color: #647EAA;
          font-weight: 400;
        }
    }

    .news-img {
        width: 174px;
        height: 121px;
        border: 1px solid #ffffff;
        border-radius: 8px;
        margin-right: 14px;
    }

    .news-info-box {
        .news-title {
            width: 241px;
            font-size: 14px;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            color: #233245;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            white-space: nowrap;
            margin-bottom: 8px;
        }

        .news-sub-title {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: #333333;
            margin-bottom: 6px;

            div {
                margin-right: 6px;
            }
        }

        .news-cnt {
            width: 243px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #333333;
            margin-bottom: 13px;
            display: -webkit-box;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }

        .news-btn {
            width: 70px;
            height: 24px;
            border-radius: 12px;
            border: 1px solid rgba(0, 37, 100, 0.6);
            text-align: center;
            line-height: 20px;
            color: #002564;
            font-size: 12px;
            font-family: MicrosoftYaHei;
            cursor: pointer;
        }
    }
}
</style>